module.exports = __webpack_public_path__ + "img/clock.3bdf911a.svg";